// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"styles_optionsWrapper__s3ZvW","optionsDots":"styles_optionsDots__x+3Wl","options":"styles_options__bNS0O","item":"styles_item__vri5R","icon":"styles_icon__SwaBN"};